<template>
  <footer>
    <div class="font-size-xl-large first-div-footer">
      <section class="d-flex flex-row flex-wrap justify-content-center">
        <nav class="w-90 w-sm-60 w-md-45 w-lg-30">
          <h5>Navigation</h5>
          <hr>
          <ul class="d-flex flex-row flex-wrap justify-content-between">
            <li class="w-50" v-for="menu in getMenu">
              <font-awesome-icon :icon="menu.icon"></font-awesome-icon>
              <router-link class="text-capitalize" :to="menu.path">{{ menu.titre }}</router-link>
            </li>
          </ul>
        </nav>
        <hr class="w-75 w-sm-45 d-md-none separator">
        <div class="w-90 w-sm-60 w-md-45 w-lg-30 align-self-center text-center div-1">
          <h5>TARIFS</h5>
          <button type="button" class="mt-3 button-type-1" @click="navigateTo('tarification')">Nos tarifs</button>
        </div>
        <hr class="w-75 w-sm-45 w-md-80 d-lg-none separator">
        <div class="w-90 w-sm-60 w-md-45 w-lg-30 align-self-center text-center div-1">
          <h5>Pays pris en charge:</h5>
          <div class="mt-2">
            <div id="carouselPays" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img :key="country.id"
                       v-for="country in getDefaultCountries.slice(0, 5)"
                       :alt="country.name_fr"
                       class="img-fluid"
                       width="50"
                       :src="getImgUrl(country.img_src)">
                </div>
                <div class="carousel-item">
                  <img :key="country.id"
                       v-for="country in getDefaultCountries.slice(5, 10)"
                       :alt="country.name_fr"
                       class="img-fluid"
                       width="50"
                       :src="getImgUrl(country.img_src)">
                </div>
                <div class="carousel-item">
                  <img :key="country.id"
                       v-for="country in getDefaultCountries.slice(10, 15)"
                       :alt="country.name_fr"
                       class="img-fluid"
                       width="50"
                       :src="getImgUrl(country.img_src)">
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselPays" role="button" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselPays" role="button" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </a>
            </div>
          </div>
          <a href="#" @click="navigateTo('pays-disponible')">Voir la liste complète</a>
        </div>
        <hr class="w-75 w-sm-45 w-md-80 d-lg-none separator">
        <div class="w-90 w-sm-60 w-md-100 w-lg-30 align-self-center text-center div-2">
          <p>Voudriez-vous nous contacter ?</p>
          <button type="button"
                  @click="$router.push('contact')"
                  class="button-type-1">OUI</button>
        </div>
      </section>
      <hr class="w-100 separator">
      <section class="d-flex flex-row flex-wrap justify-content-between ">
        <p class="w-md-35">
          <a title="Termes et Conditions d'utilisation"
             href="#">
            Termes et Conditions d'utilisation
          </a>
        </p>
        <p class="w-md-25 text-center">
          <a title="www.infotexto.com"
             href="http://infotexto.com">
            www.infotexto.com
          </a>
        </p>
        <p class="w-100 w-md-35 text-center text-md-right">
          <a title="© copyright. Tous droits réservés"
             href="#">
            © copyright. Tous droits réservés
          </a>
        </p>
      </section>
    </div>
  </footer>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: "Footer",
  props: {},
  components: {},
  data(){
    return{}
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
    navigateTo(route){
      this.$router.push(route)
    },
    getImgUrl(img_src) {
      const images = require.context('../../assets/img/countries/svg/', false, /\.svg$/)
      return images('./' + img_src)
    }
  },
  computed: {
    ...mapGetters([
      'getCountries',
      'getDefaultCountries',
      'getMenu',
    ]),
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
footer{
  color: var(--color-second);
  background: var(--color-first);
  background-image: url(../../assets/img/bg-2.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  & > div.first-div-footer{
    padding: 1rem .5rem;
    background: var(--color-first-0-5);
    & > section:first-child{
      & > nav{
        & > h5, & > hr{
          margin: 0;
        }
        & > h5{}
        & > hr{
          opacity: 1;
          border: none;
          height: 1px;
        }
        & > ul{
          list-style-type: none;
          padding-left: 0;
          padding-right: 0;
          margin-bottom: 0;
          & > li{
            & > a{
              color: var(--color-second);
            }
          }
        }
      }
      & > div.div-1{
        & > h5{
          margin: 0;
        }
        & > div{
          & > div.carousel{
            & > div.carousel-inner{
              & > div.carousel-item{
                & > img{
                  margin: 0 .2rem;
                }
              }
            }
          }
        }
        & > a{
          color: var(--color-second);
          text-decoration: underline;
        }
        & > a:hover{
          text-decoration: none;
        }
      }
      & > div.div-2{
        & > p{
          margin: 0;
        }
      }
      & > hr.separator{
        margin: 1rem 0 .5rem 0;
      }
    }
    & > section:last-child{
      & > p{
        margin: 0;
        & > a{
          color: var(--color-second)
        }
      }
    }
  }
  & > div.modal{
    & > div.modal-dialog{
      & > div.modal-content{
        & > div.modal-header{
          background: var(--color-linear-gradient-3);
        }
        & > div.modal-body {
          padding: 0;
        }
      }
    }
  }
}
@media (min-width: 576px) {}

@media (min-width: 768px) {}

@media (min-width: 992px) {}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue